import { SVGProps } from 'react'

export const Stats = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 3.25H21.25V21.25H3.25V3.25ZM4.75 13V19.75H19.75V13H16.0614L14.289 9.84909L10.289 17.8491L7.56136 13H4.75ZM19.75 11.5V4.75H4.75V11.5H8.43864L10.211 14.6509L14.211 6.65091L16.9386 11.5H19.75Z"
      fill="currentColor"
    />
  </svg>
)

